/**
 * Grabs the contents of a `jsonScript` created JSON inline string and returns
 * it as a JSON object. If the element does not exist, or if the script
 * element does not have the JSON MIME type, null is returned instead.
 *
 * @param  {string} elementId the ID of the JSON script element
 * @param  {any} [reviver] the optional reviver function passed to JSON.parse
 * @return {Object|null}
 */
export function loadJsonScript(elementId, reviver) {
  const element = document.getElementById(elementId);
  if (element && element.getAttribute('type') === 'application/json') {
    return JSON.parse(element.textContent, reviver);
  } else {
    return null;
  }
}
